import React from 'react'
import StaffsBox from './StaffsBox'
import { StaffTypeWrapper } from './styles'

export const ExternalStaffs = () => {
  return (
    <StaffTypeWrapper>
      <StaffsBox type={'host'} />
      <StaffsBox type={'mandataire'} />
    </StaffTypeWrapper>
  )
}
